/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './upsertSet.defs.js'
export * as $defs from './upsertSet.defs.js'
